/**
 * Para formatlama — tek kaynak (AdminAccounting, AdminInvoices, CheckoutPage vb.)
 *
 * Çıktı örneği: "1.234,56 ₺"
 * Locale: tr-TR, currency: TRY, Intl.NumberFormat tabanlı.
 *
 * Faz 3.7a: gercek formatlama mantigi utils/money.js::formatCurrencyIntl
 * cekirdegine tasindi. Bu dosya AYNI parametrelerle onu cagiran INCE bir
 * sarmalayici — cikti DAVRANISI oncekiyle birebir aynidir (bkz.
 * __tests__/utils/money.test.js parity testleri). Import yolu ve fonksiyon
 * adi (12 dosyadan `import { fmtTRY } from '.../utils/formatCurrency'`)
 * KORUNDU.
 */
import { formatCurrencyIntl } from './money';

/**
 * fmtTRY(1234.5) → "1.234,50 ₺"
 * fmtTRY(null)   → "0,00 ₺"
 */
export function fmtTRY(val) {
  return formatCurrencyIntl(val, {
    locale: 'tr-TR',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default fmtTRY;
